var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(852 2322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.3,7680v-5a6.082,6.082,0,0,0-12.162,0v5a3.944,3.944,0,0,1-.542,2h13.247A3.943,3.943,0,0,1,553.3,7680Zm4.054,4h-20.27a1,1,0,1,1,0-2,2.014,2.014,0,0,0,2.027-2v-5a8.109,8.109,0,0,1,16.216,0v5a2.014,2.014,0,0,0,2.027,2A1,1,0,1,1,557.354,7684Zm-7.505,3.5a3.061,3.061,0,0,1-5.26,0,1,1,0,0,1,.877-1.5h3.507A1,1,0,0,1,549.849,7687.5Z",
    transform: "translate(-1384.07 -9984.998)",
    fill: "#809fb8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-852 -2322)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.dbf08061180c12a24b29febcba309efe.svg";
export { ForwardRef as ReactComponent };